<script>
/* eslint-disable */
import cities from "@/assets/json/addressData.json";
import axios from "axios";
export default {
	name: "testdrive",
	props: {
		isActiveTestdrive: {
			type: Boolean,
			required: true,
		},
		isActiveRuleFromForm: {
			type: Boolean,
			required: true,
		},
		isActiveSucessfromForm: {
			type: Boolean,
			required: true,
		},
		testdrive_use_info: {
			type: Boolean,
			required: true,
		},
		carId: {
			type: String,
			required: true,
		},
		carNo: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			userInfo: {
				gender: "",
				countyIndex: 0,
				districtIndex: 0,
				contact_way: "",
				contact_time: "",
				exchange_brand: "",
				exchange_currentcar: "",
				exchange_exterior_color: "",
				license: null,
				front_view: null,
				rear_view: null,
				interior: null,
			},
			isLockBtn: false,
		};
	},
	computed: {
		hostUrl() {
			return this.$store.state.hostUrl;
		},
		cities() {
			return cities;
		},
		areas() {
			return cities[this.userInfo.countyIndex].areas;
		},
		allBrand() {
			return this.$store.state.allBrand;
		},
		allColorCategory() {
			return this.$store.state.allColorCategory;
		},
	},
	watch: {
		"userInfo.countyIndex": {
			handler: function () {
				let vm = this;
				vm.userInfo.districtIndex = 0;
			},
		},
		"userInfo.exchange_series": {
			handler: function (newV) {
				let vm = this;
				axios
					.post(vm.hostUrl + "/api/AllModel/" + newV)
					.then(function (response) {
						vm.allModel = [];
						vm.allModel = response.data;
					})
					.catch(function (error) {
						console.log(error);
					});
			},
		},
	},
	mounted() {
		let vm = this;
		vm.$store.dispatch("GETALLBRAND");
		vm.$store.dispatch("GETALLCOLORCATEGORY");
	},
	methods: {
		onBrandChange() {
			// console.log("onBrandChange")
			let vm = this;
			vm.userInfo.exchange_currentcar = vm.allBrand[vm.userInfo.exchange_brand][0];
		},
		checkFile(element, type) {
			// console.log('checkFile');
			let vm = this;
			let SizeLimit = 3145728;
			let files = element.target.files;
			if (files.length >= 1) {
				if (files[0].size > SizeLimit) {
					alert("*僅限上傳 jpg 格式照片，檔案大小 3 MB 以內");
				} else {
					vm.userInfo[type] = files[0];
				}
			} else {
				vm.userInfo[type] = null;
			}
		},
		checkForm() {
			// console.log("checkForm")
			let vm = this;

			vm.$gtag.event("testdrive", {
				event_category: "submit",
				event_label: `${vm.carNo}`,
				send_to: ["UA-124821034-1", "G-CYXF981YFQ"],
			});

			if (!vm.userInfo.lastname) {
				alert("請填寫您的姓氏");
				const element =
					document.querySelector(".testdrive #lastname").parentNode.previousSibling;
				element.scrollIntoView({
					behavior: "smooth",
					block: "nearest",
					inline: "nearest",
				});
				return false;
			}
			if (!vm.userInfo.firstname) {
				alert("請填寫您的名字");
				const element =
					document.querySelector(".testdrive #firstname").parentNode.previousSibling;
				element.scrollIntoView({
					behavior: "smooth",
					block: "nearest",
					inline: "nearest",
				});
				return false;
			}
			if (!vm.userInfo.gender) {
				alert("請選擇您的稱謂");
				const element =
					document.querySelector(".testdrive #gender").parentNode.previousSibling;
				element.scrollIntoView({
					behavior: "smooth",
					block: "nearest",
					inline: "nearest",
				});
				return false;
			}
			if (!vm.userInfo.mobile) {
				alert("請填寫您的手機號碼");
				const element =
					document.querySelector(".testdrive #mobile").parentNode.previousSibling;
				element.scrollIntoView({
					behavior: "smooth",
					block: "nearest",
					inline: "nearest",
				});
				return false;
			} else {
				let validMobile = /^09\d{8}$/;
				if (!validMobile.test(vm.userInfo.mobile)) {
					alert("手機號碼格式錯誤");
					return false;
				}
			}
			if (vm.userInfo.countyIndex === 0) {
				alert("請選擇縣市");
				const element =
					document.querySelector(".testdrive #county").parentNode.previousSibling;
				element.scrollIntoView({
					behavior: "smooth",
					block: "nearest",
					inline: "nearest",
				});
				return false;
			}
			if (!vm.userInfo.address_detail) {
				alert("請填寫您的詳細地址");
				const element = document.querySelector(".testdrive #address_detail").parentNode
					.previousSibling;
				element.scrollIntoView({
					behavior: "smooth",
					block: "nearest",
					inline: "nearest",
				});
				return false;
			}
			if (!vm.userInfo.email) {
				alert("請填寫您的E-mail");
				const element =
					document.querySelector(".testdrive #email").parentNode.previousSibling;
				element.scrollIntoView({
					behavior: "smooth",
					block: "nearest",
					inline: "nearest",
				});
				return false;
			} else {
				let validEmail =
					/^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
				if (!validEmail.test(vm.userInfo.email)) {
					alert("E-mail格式錯誤");
					return false;
				}
			}
			if (!vm.userInfo.contact_way) {
				alert("請選擇方便聯絡方式");
				const element = document.querySelector(".testdrive #contact_mobile").parentNode
					.previousSibling;
				element.scrollIntoView({
					behavior: "smooth",
					block: "nearest",
					inline: "nearest",
				});
				return false;
			}
			if (vm.userInfo.contact_way === "手機" && !vm.userInfo.contact_time) {
				alert("請選擇方便聯絡時間");
				const element = document.querySelector(".testdrive #contact_time1").parentNode
					.previousSibling;
				element.scrollIntoView({
					behavior: "smooth",
					block: "nearest",
					inline: "nearest",
				});
				return false;
			}
			if (!vm.userInfo.isExchange) {
				alert("請選擇是否有換購 BMW 新車需求");
				const element =
					document.querySelector(".testdrive #exchangeY").parentNode.previousSibling;
				element.scrollIntoView({
					behavior: "smooth",
					block: "nearest",
					inline: "nearest",
				});
				return false;
			}

			//有換購需求
			if (vm.userInfo.isExchange === "Y") {
				if (!vm.userInfo.exchange_brand) {
					alert("請選擇現有車款品牌");
					const element = document.querySelector(".testdrive #exchange_brand").parentNode
						.previousSibling;
					element.scrollIntoView({
						behavior: "smooth",
						block: "nearest",
						inline: "nearest",
					});
					return false;
				}
				if (
					!vm.userInfo.exchange_currentcar &&
					vm.allBrand[vm.userInfo.exchange_brand].length > 0
				) {
					alert("請選擇現有車款");
					const element = document.querySelector(".testdrive #exchange_currentcar")
						.parentNode.previousSibling;
					element.scrollIntoView({
						behavior: "smooth",
						block: "nearest",
						inline: "nearest",
					});
					return false;
				}
				if (!vm.userInfo.exchange_mileage) {
					alert("請填寫里程數");
					const element = document.querySelector(".testdrive #exchange_mileage")
						.parentNode.previousSibling;
					element.scrollIntoView({
						behavior: "smooth",
						block: "nearest",
						inline: "nearest",
					});
					return false;
				}
				if (!vm.userInfo.exchange_fac_year) {
					alert("請填寫出廠年份");
					const element = document.querySelector(".testdrive #exchange_fac_year")
						.parentNode.previousSibling;
					element.scrollIntoView({
						behavior: "smooth",
						block: "nearest",
						inline: "nearest",
					});
					return false;
				}
				if (!vm.userInfo.exchange_fac_month) {
					alert("請填寫出廠月份");
					const element = document.querySelector(".testdrive #exchange_fac_month")
						.parentNode.previousSibling;
					element.scrollIntoView({
						behavior: "smooth",
						block: "nearest",
						inline: "nearest",
					});
					return false;
				}
				if (!vm.userInfo.exchange_lic_year) {
					alert("請填寫領牌年份");
					const element = document.querySelector(".testdrive #exchange_lic_year")
						.parentNode.previousSibling;
					element.scrollIntoView({
						behavior: "smooth",
						block: "nearest",
						inline: "nearest",
					});
					return false;
				}
				if (!vm.userInfo.exchange_lic_month) {
					alert("請填寫領牌月份");
					const element = document.querySelector(".testdrive #exchange_lic_month")
						.parentNode.previousSibling;
					element.scrollIntoView({
						behavior: "smooth",
						block: "nearest",
						inline: "nearest",
					});
					return false;
				}
			}

			if (!vm.testdrive_use_info) {
				alert("請點擊展開詳讀資料使用同意條款，並點選「同意條款」按鈕以完成此項目勾選");
				const element = document.querySelector(".testdrive #exchange_lic_month").parentNode;
				element.scrollIntoView({
					behavior: "smooth",
					block: "nearest",
					inline: "nearest",
				});
				return false;
			}

			vm.isLockBtn = true;
			vm.sendData();
		},
		sendData() {
			// console.log("sendData")
			let vm = this;

			const formData = new FormData();
			formData.append("car_id", vm.carId);
			formData.append("lastname", vm.userInfo.lastname);
			formData.append("firstname", vm.userInfo.firstname);
			formData.append("gender", vm.userInfo.gender);
			formData.append("mobile", vm.userInfo.mobile);
			formData.append("county", vm.cities[vm.userInfo.countyIndex].name);
			formData.append(
				"district",
				vm.cities[vm.userInfo.countyIndex].areas[vm.userInfo.districtIndex].name,
			);
			formData.append("address_detail", vm.userInfo.address_detail);
			formData.append("email", vm.userInfo.email);
			formData.append("contact_way", vm.userInfo.contact_way);
			formData.append(
				"contact_time",
				vm.userInfo.contact_way === "手機" ? vm.userInfo.contact_time : "",
			);
			formData.append("remarks", vm.userInfo.remarks ? vm.userInfo.remarks : "無");
			formData.append("edm", vm.userInfo.edm ? "edm" : "");
			formData.append("exchange", vm.userInfo.isExchange);
			if (vm.userInfo.isExchange === "Y") {
				formData.append("exchange_brand", vm.userInfo.exchange_brand);
				formData.append(
					"exchange_currentcar",
					vm.userInfo.exchange_currentcar ? vm.userInfo.exchange_currentcar : "",
				);
				formData.append(
					"exchange_exterior_color",
					vm.userInfo.exchange_exterior_color ? vm.userInfo.exchange_exterior_color : "",
				);
				formData.append(
					"exchange_mileage",
					vm.userInfo.exchange_mileage ? vm.userInfo.exchange_mileage : "",
				);
				formData.append(
					"exchange_fac_year",
					vm.userInfo.exchange_fac_year ? vm.userInfo.exchange_fac_year : "",
				);
				formData.append(
					"exchange_fac_month",
					vm.userInfo.exchange_fac_month ? vm.userInfo.exchange_fac_month : "",
				);
				formData.append(
					"exchange_lic_year",
					vm.userInfo.exchange_lic_year ? vm.userInfo.exchange_lic_year : "",
				);
				formData.append(
					"exchange_lic_month",
					vm.userInfo.exchange_lic_month ? vm.userInfo.exchange_lic_month : "",
				);
				formData.append("license", vm.userInfo.license);
				formData.append("front_view", vm.userInfo.front_view);
				formData.append("rear_view", vm.userInfo.rear_view);
				formData.append("interior", vm.userInfo.interior);
			}

			axios
				.post(vm.hostUrl + "/api/Testdrive", formData)
				.then(function (response) {
					if (response.data.status === 0) {
						vm.userInfo = {};
						vm.userInfo = {
							gender: "",
							countyIndex: 0,
							districtIndex: 0,
							contact_way: "",
							contact_time: "",
							contact_dealer: "",
							series: "",
							model_name: "",
							exterior_color: "",
							interior_color: "",
							budget: "",
							exchange_brand: "",
							exchange_currentcar: "",
							exchange_exterior_color: "",
							use_info: false,
							license: null,
							front_view: null,
							rear_view: null,
							interior: null,
						};
						vm.$emit("update:testdrive_use_info", false);
						vm.$emit("update:isActiveTestdrive", false);
						vm.$emit("update:isActiveSucessfromForm", true);
						vm.$gtag.event("event", {
							event_category: "conversion",
							send_to: "AW-451827930/S0LACM7MvoYYENqxudcB",
						});
						vm.$gtag.event("testdrive", {
							event_category: "complete",
							event_label: `${vm.carNo}`,
							send_to: ["UA-124821034-1", "G-CYXF981YFQ"],
						});
						fbq("trackSingle", "436643020262829", "Lead");
						fbq("trackSingle", "2320616348184878", "Lead");
						_lt(
							"send",
							"cv",
							{
								type: "Conversion",
							},
							["f318243c-e326-4eae-ab95-2a016ce79687"],
						);

						window.dotq = window.dotq || [];
						window.dotq.push({
							projectId: "10000",
							properties: {
								pixelId: "10197090",
								qstrings: {
									et: "custom",
									ea: "sellcar_submit",
								},
							},
						});
					} else {
						alert(response.data.message);
					}
					vm.isLockBtn = false;
				})
				.catch(function (error) {
					console.log(error);
				});
		},
		testdriveToggle() {
			// console.log("testdriveToggle")
			let vm = this;
			vm.$emit("update:isActiveTestdrive", false);
		},
		lightboxToggle() {
			// console.log("lightboxToggle")
			let vm = this;
			vm.$emit("update:isActiveRuleFromForm", true);
		},
	},
};
</script>

<template src="./template.pug" lang="pug"></template>
<style src="./style.sass" lang="sass" scoped>
@import "@/assets/sass/_variable.sass"
@import "@/assets/sass/_mixin.sass"
</style>
